import React from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const arrowStyle = {
  color: "white",
  backgroundColor: "#76A4AD",
  padding: "22px 12px",
  fontSize: 14,
};

function Arrow({ direction, count, index, setIndex, setStopChange }) {
  return (
    <div
      style={{
        cursor: "pointer",
        position: "absolute",
        display: "inline",
        top: "54vh",
        left: direction === "right" ? null : 0,
        right: direction === "left" ? null : 0,
        zIndex: 100,
      }}
      onClick={() => {
        if (direction === "right") {
          if (index < count - 1) setIndex(index + 1);
        }
        if (direction === "left") {
          if (index > 0) setIndex(index - 1);
        }
        // go from last village to first, and from first to last
        // if (direction === "right") {
        //   index === count - 1 ? setIndex(0) : setIndex(index + 1);
        // }
        // if (direction === "left") {
        //   index === 0 ? setIndex(count - 1) : setIndex(index - 1);
        // }
        setStopChange(true);
      }}
    >
      {direction === "right" ? (
        <div style={arrowStyle}>{">"}</div>
      ) : (
        // <IoIosArrowForward color="white" size={50} />
        <div style={arrowStyle}>{"<"}</div>
        // <IoIosArrowBack color="white" size={50} />
      )}
    </div>
  );
}

export default Arrow;
